export enum BULLJSQUEUENAMESTOMODULEMAP {
    SAMPLE_JOB = 'WH',
    ASSET_ACTIVITY_CONTROLLER_JOB = 'ASM',
}
